///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.checkbooks = abcsetup.promos.checkbooks || {};
abcsetup.promos.checkbooks.summary = abcsetup.promos.checkbooks.summary || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.checkbooks.summary = {
    init() {
        abcsetup.setTitle('Promotional Checkbook');

        abcsetup.promos.checkbooks.setupPromoSupplierItemsModal(true);
        abcsetup.promos.checkbooks.setupAccordions();
    },
}
